"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupedProducts = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _internal = require("../../hooks/internal");
var _constants = require("./constants");
var _styled = require("./styled");
var _jsxRuntime = require("react/jsx-runtime");
const GroupedProducts = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    currentProduct: {
      code,
      groupedProducts
    },
    onGroupedProductCodeClick
  } = (0, _internal.useProduct)();
  const isActive = (0, _react.useCallback)(productCode => productCode === code, [code]);
  if (groupedProducts.length < 2) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.Root, {
    "data-testid": getTestId(_constants.GROUPED_PRODUCTS),
    children: groupedProducts.map(({
      label,
      productCode
    }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Chip, {
      "data-testid": getTestId(`${_constants.GROUPED_PRODUCT}-${productCode}`),
      label: label,
      variant: isActive(productCode) ? 'filled' : 'outlined',
      size: "small",
      onClick: isActive(productCode) ? undefined : onGroupedProductCodeClick(productCode)
    }, productCode))
  });
};
exports.GroupedProducts = GroupedProducts;